import { useEffect } from "react";
import stylesTabel from "../../styles/Tabel.module.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useDispatch, useSelector } from "react-redux";
// import { FaRegEdit } from "react-icons/fa";
import moment from "moment";

import { getUsers } from "../../store/EmployeesSlice";
// import { useNavigate } from "react-router-dom";

const Users = () => {
  // const navigate = useNavigate();
  const { UsersData } = useSelector((state) => state.EmployeesSlice);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!UsersData) {
      dispatch(getUsers());
    }
  }, [dispatch, UsersData]);

  // const StateBody = (rowData) => {
  //   return (
  //     <div className="StatusBtn6">
  //       <button
  //         className="  edite_btn"
  //         onClick={() => {
  //           navigate(`/admins/${rowData?.id}`);
  //         }}
  //       >
  //         <FaRegEdit />
  //       </button>
  //     </div>
  //   );
  // };

  return (
    <div className="Tabel_container">
      <div className="flex justify-content-between align-items-center  tilte_page">
        <p>قائمة المستخدمين</p>
      </div>
      <div className={stylesTabel.Tabel}>
        <DataTable
          tableStyle={{ minWidth: "50rem" }}
          value={UsersData}
          className={`${stylesTabel.dataTabel}`}
          rows={10}
          dataKey="id"
          responsiveLayout="scroll"
          emptyMessage="  لا يوجد بيانات متاحة  "
          stripedRows
          paginator
        >
          <Column field="id" header="#" />
          <Column field="name" header="الاسم" />
          <Column field="phone" header="رقم الهاتف" />
          <Column field="email" header="البريد الإلكتروني" />
          <Column
            field="gender"
            body={(row) => <>{row?.gender === "man" ? "رجل" : "امراة"}</>}
            header="الاسم"
          />
          <Column
            field="created_at"
            body={(row) => <>{moment(row?.created_at).format("llll")}</>}
            header="تاريخ الانشاء"
          />

          {/* <Column body={StateBody} header="  تعديل " /> */}
        </DataTable>
      </div>
    </div>
  );
};

export default Users;
